import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import More from 'highcharts/highcharts-more';
import highcharts3D from 'highcharts/highcharts-3d';
highcharts3D(Highcharts);
More(Highcharts);
import { HttpClient } from '@angular/common/http';
import { ScatterchartService } from '../../scatterchart.service';
import { BarserviceService } from '../../../../barchart/barchart/barservice.service';
import { Observable, Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { max } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { SignificanceService } from 'src/app/common/services/significance.service';



@Component({
  selector: 'app-bubble-chart-custom',
  templateUrl: './bubblechart02.component.html',
  styleUrls: [],
})
export class Bubblechart02ComponentCustom implements OnInit {
  chart: any;
  seriesData: any = [];
  chartproperties: any;
  sampleSizeConstandValue = 12000;
  quadrantText: any;
  properties: any;
  title: any;
  //@Input() height="25em";
  data: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any;
  color: any;
  configuredProperties: any = {};
  private subscriptions: Subscription = new Subscription();
  significanceValue: any = "None";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
  chartMainData: any;
  xAxisTitle: any = "";
  yAxisTitle: any = "";
  zAxisTitle: any = "";
  percentageForX : boolean = false;
  percentageForY : boolean = false;
  percentageForZ : boolean = false;
  userselectedchartdata: any;
  constructor(private http: HttpClient,
    private scatterchartService: ScatterchartService,
    private barService: BarserviceService,
    private _customSnapshotService: CustomsnapshotService,
    private _configService: SnapshotService,
    private route: ActivatedRoute,
    private significanceService: SignificanceService) { }

  ngOnInit(): void {
    if (this.isOutput) {
      if (this.sort == 0) {
        this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
      }
      
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric;

     
      //this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));

      // this.maxDataPoints = this.layoutNumber == 2 ? 12 : this.popUp ? 10 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));

    }
    else {
      this.http.get<any>('assets/Data/bubbleData.json').subscribe((data: any) => {
        this.quadrantText = data[0]["quadrantText"][0];
        const snapshottype_name= sessionStorage.getItem('issnapshottype');
        if (Array.isArray(data[0]["data"])) {
          let i=0;
         
          this.seriesData = data[0]["data"].map((brandData: any,brandIndex: number) => {
            let updatedBrand:string;

            if(snapshottype_name=='Multiple Markets'){
              updatedBrand=`Market ${brandIndex + 1}`

            }else if(snapshottype_name=='Multiple Categories'){
              updatedBrand= `Category ${brandIndex + 1}`;
            }else{
              updatedBrand=brandData.brand;
            }

            return {
              
              brand: updatedBrand,
              data: brandData.data.map((item: any) => ({
                
                

                x: item['X-Values'],
                y: item['Y-Values'],
                size: item.Size,
                metric: updatedBrand,
                significance: item.Significance,
                significance1: item.Significance1,
                cv: item['ChangeVs'],
                samplesize: item['Sample size'],
              })),
            };
          });
        }
        this.title = data[0]["title"];
        this.chartproperties = data[0]["properties"][0];
        this.chartproperties.showLegend = true;
        this.properties = data[0]["properties"];
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.chartproperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        
        this.getBubbleChart('chart-container' + this.id, this.seriesData, this.chartproperties);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customData'] && !changes['customData'].firstChange) {
      if (this.isOutput) {
        this.configuredProperties = JSON.parse(this.customData.customizationProperties);
        this.customData = this.customData.metric;
        this.updateSig();
      }
    }
  }

  updateSig() {
    this.updateSigSub?.unsubscribe();
    this.updateSigSub = this.http.get<any>('assets/Data/bubbleData.json').subscribe((data: any) => {
        // this.jsondata = data;
        //this.data = data[0];
        this.data = data[0]["data"];
        this.chartproperties = data[0]["properties"][0];
        // ;
        this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "default" : "sigChange";
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
        this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
        this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);
        if (this.customData) {
          this.preparemainChartData(this.customData);
          
          this.seriesData = this.chartMainData.map((brandData: any) => {
            return {
              brand: brandData.brand,
              data: brandData.data.map((item: any) => ({
                x: item['x'],
                y: item['y'],
                z: item['z'],
                size: item['z'], // Dynamically set based on your dataset
                metric: item.Metric,
                significance: item.Significance,
                significance1: item.Significance1,
                covx: item['ChangeVsx'],
                covy: item['ChangeVsy'],
                covz: item['ChangeVsz'],
                samplesizex: item['Sample sizex'],
                samplesizey: item['Sample sizey'],
                samplesizez: item['Sample sizez'],
                indexValuex: (Number(item['Sample sizex']) <= this._configService.ISthreshold ? 0 : (item['ValueForIndexx'] == null ? 0 : item['ValueForIndexx'])),
                actualIndexValuex: item['ActualIndexValuex'],
                indexValuey: (Number(item['Sample sizey']) <= this._configService.ISthreshold ? 0 : (item['ValueForIndexy'] == null ? 0 : item['ValueForIndexy'])),
                actualIndexValuey: item['ActualIndexValuey'],
                indexValuez: (Number(item['Sample sizez']) <= this._configService.ISthreshold ? 0 : (item['ValueForIndexz'] == null ? 0 : item['ValueForIndexz'])),
                actualIndexValuez: item['ActualIndexValuez'],
                tooltip: "",
                isNullDataX: item["isNullDataX"],
                isNullDataY: item["isNullDataY"],
                isNullDataZ: item["isNullDataZ"],
                isPercentageX: item["isPercentageX"],
                isPercentageY: item["isPercentageY"],
                isPercentageZ: item["isPercentageZ"],
                Sig_LowerLimt: this.Sig_LowerLimt,
                Sig_UpperLimt: this.Sig_UpperLimt,
                Significance_Valuex: item["Significance_Valuex"],
                Significance_Valuey: item["Significance_Valuey"],
                Significance_Valuez: item["Significance_Valuez"],
                color: item["color"],
                colorLinearGradient: item["colorLinearGradient"]
              })),
            };
          });
        }
        // ── HARDCODED TEST: mixed +ve / -ve Y values ──────────────────────────
        // this.seriesData = [
        //   { brand: 'Bluehold Financial',   data: [{ x: 6,  y: -31, size: 93, metric: '', significance: '0', significance1: '0', covx: null, covy: null, covz: null, samplesizex: 15000, samplesizey: 15000, samplesizez: 15000, indexValuex: 0, actualIndexValuex: null, indexValuey: 0, actualIndexValuey: null, indexValuez: 0, actualIndexValuez: null, tooltip: '', isPercentageX: false, isPercentageY: false, isPercentageZ: false, Sig_LowerLimt: this.Sig_LowerLimt, Sig_UpperLimt: this.Sig_UpperLimt, Significance_Valuex: null, Significance_Valuey: null, Significance_Valuez: null, isNullDataX: false, isNullDataY: false, isNullDataZ: false }] },
        //   { brand: 'Sproutvest Finance',   data: [{ x: 15, y:  25, size: 69, metric: '', significance: '0', significance1: '0', covx: null, covy: null, covz: null, samplesizex: 15000, samplesizey: 15000, samplesizez: 15000, indexValuex: 0, actualIndexValuex: null, indexValuey: 0, actualIndexValuey: null, indexValuez: 0, actualIndexValuez: null, tooltip: '', isPercentageX: false, isPercentageY: false, isPercentageZ: false, Sig_LowerLimt: this.Sig_LowerLimt, Sig_UpperLimt: this.Sig_UpperLimt, Significance_Valuex: null, Significance_Valuey: null, Significance_Valuez: null, isNullDataX: false, isNullDataY: false, isNullDataZ: false }] },
        //   { brand: 'VaultQuest',           data: [{ x: 9,  y: -61, size: 95, metric: '', significance: '0', significance1: '0', covx: null, covy: null, covz: null, samplesizex: 15000, samplesizey: 15000, samplesizez: 15000, indexValuex: 0, actualIndexValuex: null, indexValuey: 0, actualIndexValuey: null, indexValuez: 0, actualIndexValuez: null, tooltip: '', isPercentageX: false, isPercentageY: false, isPercentageZ: false, Sig_LowerLimt: this.Sig_LowerLimt, Sig_UpperLimt: this.Sig_UpperLimt, Significance_Valuex: null, Significance_Valuey: null, Significance_Valuez: null, isNullDataX: false, isNullDataY: false, isNullDataZ: false }] },
        //   { brand: 'Evertrue Funds',       data: [{ x: 20, y:  30, size: 77, metric: '', significance: '0', significance1: '0', covx: null, covy: null, covz: null, samplesizex: 15000, samplesizey: 15000, samplesizez: 15000, indexValuex: 0, actualIndexValuex: null, indexValuey: 0, actualIndexValuey: null, indexValuez: 0, actualIndexValuez: null, tooltip: '', isPercentageX: false, isPercentageY: false, isPercentageZ: false, Sig_LowerLimt: this.Sig_LowerLimt, Sig_UpperLimt: this.Sig_UpperLimt, Significance_Valuex: null, Significance_Valuey: null, Significance_Valuez: null, isNullDataX: false, isNullDataY: false, isNullDataZ: false }] },
        //   { brand: 'Silverridge Advisory', data: [{ x: 15, y: -65, size: 77, metric: '', significance: '0', significance1: '0', covx: null, covy: null, covz: null, samplesizex: 15000, samplesizey: 15000, samplesizez: 15000, indexValuex: 0, actualIndexValuex: null, indexValuey: 0, actualIndexValuey: null, indexValuez: 0, actualIndexValuez: null, tooltip: '', isPercentageX: false, isPercentageY: false, isPercentageZ: false, Sig_LowerLimt: this.Sig_LowerLimt, Sig_UpperLimt: this.Sig_UpperLimt, Significance_Valuex: null, Significance_Valuey: null, Significance_Valuez: null, isNullDataX: false, isNullDataY: false, isNullDataZ: false }] },
        //   { brand: 'Guardia Funds',        data: [{ x: 28, y:  20, size: 92, metric: '', significance: '0', significance1: '0', covx: null, covy: null, covz: null, samplesizex: 15000, samplesizey: 15000, samplesizez: 15000, indexValuex: 0, actualIndexValuex: null, indexValuey: 0, actualIndexValuey: null, indexValuez: 0, actualIndexValuez: null, tooltip: '', isPercentageX: false, isPercentageY: false, isPercentageZ: false, Sig_LowerLimt: this.Sig_LowerLimt, Sig_UpperLimt: this.Sig_UpperLimt, Significance_Valuex: null, Significance_Valuey: null, Significance_Valuez: null, isNullDataX: false, isNullDataY: false, isNullDataZ: false }] },
        // ];
        // ── END HARDCODED TEST ─────────────────────────────────────────────────
        // this.getData(this.jsondata, this.chartproperties.datalabelStyle == "ls");
        this.getBubbleChart('chart-container' + this.id, this.seriesData, this.chartproperties,
        );
      });

  }


  preparemainChartData(data: any) {
    let i = 0;
    data.forEach((item: any) => {
      item.metric_value.forEach((d: any) => {
        const hasMean = d.option?.toLowerCase().includes("mean");
        if (item.metric_option.includes("XAxis Metric") && hasMean) {
          this.percentageForX = true;
        } else if (item.metric_option.includes("YAxis Metric") && hasMean) {
          this.percentageForY = true;
        } else if (hasMean) {
          this.percentageForZ = true;
        }
      });
    });

    this.chartMainData = [];

    const xAxisData = data.filter((a: any) => a.metric_option.toLowerCase().includes("xaxis"))[0];
    if (!xAxisData || !xAxisData.metric_value) {
      return;
    }
    
    const yAxisData = data.filter((a: any) => a.metric_option.toLowerCase().includes("yaxis"))[0];
    const zAxisData = data.filter((a: any) => a.metric_option.toLowerCase().includes("zaxis"))[0];
    
    if (!yAxisData || !yAxisData.metric_value || !zAxisData || !zAxisData.metric_value) {
      return;
    }
    
    xAxisData.metric_value.forEach((xaxis: any) => {
      this.xAxisTitle = xaxis.option
      if (!xaxis.data) {
        return;
      }
      
      xaxis.data.forEach((dataArr: any) => {

        let yaxisDataArray = yAxisData.metric_value[0].data ? yAxisData.metric_value[0].data.filter((a: any) => a.colChild == dataArr.colChild) : [];
        let zaxisDataArray = zAxisData.metric_value[0].data ? zAxisData.metric_value[0].data.filter((a: any) => a.colChild == dataArr.colChild) : [];
        
        let yaxisData = yaxisDataArray.length > 0 ? yaxisDataArray[0] : null;
        let zaxisData = zaxisDataArray.length > 0 ? zaxisDataArray[0] : null;
        
        if (!yaxisData || !zaxisData) {
          return;
        }
        
        this.yAxisTitle = yaxisData?.rowChild;
        this.zAxisTitle = zaxisData?.rowChild;
        let d1 = {
          "brand":  dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
          "data": [{
            "x":dataArr.data!==null?(dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? Number((dataArr.data * 100).toFixed(this.chartproperties.decimalRoundOff)) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : Number((dataArr.data).toFixed(this.chartproperties.decimalRoundOff)))):0,
            "y":yaxisData.data!==null?(yaxisData.CalculationType?.toLowerCase() == "share" || yaxisData.CalculationType?.toLowerCase() == "respgrp" ? Number((yaxisData.data * 100).toFixed(this.chartproperties.decimalRoundOff)) : (yaxisData.CalculationType?.toLowerCase() == "index" && yaxisData.data == "NA" ? "NA" : Number((yaxisData.data).toFixed(this.chartproperties.decimalRoundOff)))):0,
            "z":zaxisData.data!==null?(zaxisData.CalculationType?.toLowerCase() == "share" || zaxisData.CalculationType?.toLowerCase() == "respgrp" ? Number((zaxisData.data * 100).toFixed(this.chartproperties.decimalRoundOff)) : (zaxisData.CalculationType?.toLowerCase() == "index" && zaxisData.data == "NA" ? "NA" : Number((zaxisData.data).toFixed(this.chartproperties.decimalRoundOff)))):0,
            "metric": "",
            "ChangeVsx": dataArr.changeVsPY,
            "ChangeVsy": yaxisData.changeVsPY,
            "ChangeVsz": zaxisData.changeVsPY,
            "Significance": "-1",
            "Significance2": "1",
            "Sample sizex": dataArr.baseValueforLSorIs,
            "Sample sizey": yaxisData.baseValueforLSorIs,
            "Sample sizez": zaxisData.baseValueforLSorIs,
            "ValueForIndexx": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValuex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ValueForIndexy": (yaxisData.CalculationTypeIndex?.toLowerCase() == "index" && yaxisData.data2 == "NA" ? "NA" : yaxisData.data2),
            "ActualIndexValuey": (yaxisData.CalculationTypeIndex?.toLowerCase() == "index" && yaxisData.data2 == null) ? null : (yaxisData.CalculationTypeIndex?.toLowerCase() == "index" && yaxisData.data2 == "NA" ? "NA" : yaxisData.data2),
            "ValueForIndexz": (zaxisData.CalculationTypeIndex?.toLowerCase() == "index" && zaxisData.data2 == "NA" ? "NA" : zaxisData.data2),
            "ActualIndexValuez": (zaxisData.CalculationTypeIndex?.toLowerCase() == "index" && zaxisData.data2 == null) ? null : (zaxisData.CalculationTypeIndex?.toLowerCase() == "index" && zaxisData.data2 == "NA" ? "NA" : zaxisData.data2),
            "isNullDataX": dataArr.data === null,
            "isNullDataY": yaxisData.data === null,
            "isNullDataZ": zaxisData.data === null,
            "isPercentageX": (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp") && !this.percentageForX ? true : false,
            "isPercentageY": (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp") && !this.percentageForY  ? true : false,
            "isPercentageZ": (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp") && !this.percentageForZ ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Valuex": dataArr.Significance_Value,
            "Significance_Valuey": yaxisData.Significance_Value,
            "Significance_Valuez": zaxisData.Significance_Value,
             "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient
          }],
          "image": dataArr.colChild
        }

        this.chartMainData.push(d1);
      });
    });
  }

  customization(): Observable<any> {
    return this._customSnapshotService.getChartCustomization("Bubble Chart", this._customSnapshotService.selectedSnapshotType?.name);
  }

  quadrantHalfValue(seriesData: any, property: string): number {
    const values = seriesData.flatMap((item: any) => item.data.map((dataItem: any) => dataItem[property]));
    const minValue = Math.min(...values);
    const maxValue = Math.max(...values);
    return (minValue + maxValue) / 2;
  }

  
  
  //  * Used when Quadrant Position is set to 'Average of the axis coordinates'.
  //  * Formula: (X1 + X2 + ... + Xn) / n
  
  calculateAverageQuadrantValue(seriesData: any, property: string): number {
    const values = seriesData.flatMap((item: any) => item.data.map((dataItem: any) => dataItem[property]));
    const sum = values.reduce((acc: number, val: number) => acc + val, 0);
    return sum / values.length;
  }

  getQuadrantLineValue(seriesData: any, property: string, chartproperties: any): number {
    const position = chartproperties.quadrantPosition || 'midpoint';
    
    switch (position) {
      case 'average':
        return this.calculateAverageQuadrantValue(seriesData, property);
      case 'fixed':
        return property === 'x' 
          ? (chartproperties.fixedXAxisValue || 0) 
          : (chartproperties.fixedYAxisValue || 0);
      case 'midpoint':
      default:
        return this.quadrantHalfValue(seriesData, property);
    }
  }
  GetMinAxisValue(d: any, range: any) {

  let buffer = Math.abs(range) * 0.10;
  let minValue = d - buffer;
  return minValue;
}

GetMaxAxisValue(d: any, range: any) {
  let buffer = Math.abs(range) * 0.10;
  let maxValue = d + buffer;
  return maxValue;
}

  getBubbleChart(containerid: string, seriesData: any, chartproperties: any) {
    let popup=this.popUp;
    if (this.isOutput) {
      const nonNullCount = this.seriesData.reduce((sum: number, s: any) =>
        sum + s.data.filter((p: any) => !(p.isNullDataX && p.isNullDataY && p.isNullDataZ)).length, 0);
      if (nonNullCount === 0) {
        const containerElEarly = document.getElementById(containerid);
        if (containerElEarly) {
          containerElEarly.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
        }
        return;
      }
      let maxX = Math.max(
        ...this.seriesData.flatMap((series: any) =>
          series.data.map((point: any) => point.x)
        )
      );
      let maxY = Math.max(
        ...this.seriesData.flatMap((series: any) =>
          series.data.map((point: any) => point.y)
        )
      );

      let xAxisMinValue =  Math.min(
        ...this.seriesData.flatMap((series: any) =>
          series.data.map((point: any) => point.x)
        )
      );

      let xAxisMaxValue =  Math.max(
        ...this.seriesData.flatMap((series: any) =>
          series.data.map((point: any) => point.x)
        )
      );

      let yAxisMinValue =  Math.min(
        ...this.seriesData.flatMap((series: any) =>
          series.data.map((point: any) => point.y)
        )
      );

      let yAxisMaxValue =  Math.max(
        ...this.seriesData.flatMap((series: any) =>
          series.data.map((point: any) => point.y)
        )
      );

            let xRange = xAxisMaxValue - xAxisMinValue;
      xAxisMaxValue = this.GetMaxAxisValue(xAxisMaxValue, xRange);
      xAxisMinValue = this.GetMinAxisValue(xAxisMinValue, xRange);

      let yRange = yAxisMaxValue - yAxisMinValue;
      yAxisMaxValue = this.GetMaxAxisValue(yAxisMaxValue, yRange);
      yAxisMinValue = this.GetMinAxisValue(yAxisMinValue, yRange);
      
      xAxisMinValue = Math.floor(xAxisMinValue);
      xAxisMaxValue = Math.ceil(xAxisMaxValue);

      yAxisMinValue = Math.floor(yAxisMinValue);
      yAxisMaxValue = Math.ceil(yAxisMaxValue);
      
      // Round x-axis to nearest 10; keep y-axis min as integer floor to avoid excessive empty space
      xAxisMinValue = Math.floor(xAxisMinValue / 10) * 10;
      xAxisMaxValue = Math.ceil(xAxisMaxValue / 10) * 10;

      yAxisMaxValue = Math.ceil(yAxisMaxValue / 10) * 10 + 10;
      yAxisMinValue = Math.floor(yAxisMinValue);
    
      // Calculate quadrant line positions based on selected mode
      let yAxisPlotLine = this.getQuadrantLineValue(seriesData, 'y', this.chartproperties);
      let xAxisPlotLine = this.getQuadrantLineValue(seriesData, 'x', this.chartproperties);
      
      let properties = this.chartproperties;
      localStorage.setItem("properties", JSON.stringify(chartproperties));
      const threshold = this._configService?.ISthreshold ?? 0;
      const isNonSuperAdmin = true;
      // Output branch: build series
      const tempSeries: any[] = [];
      let hasAnyIS = false;
      seriesData.forEach((item: any, index: number) => {
        const brandInfo: any = this.scatterchartService.bubbleupdatedCategories.find(
          (category: { name: any }) => category.name === item.brand);

        const mappedPoints = item.data.map((dataItem: any) => {
          const sx = Number(dataItem.samplesizex ?? 0);
          const sy = Number(dataItem.samplesizey ?? 0);
            const sz = Number(dataItem.samplesizez ?? 0);
          const isIS = isNonSuperAdmin && (sx <= threshold || sy <= threshold || sz <= threshold);
          return {
            x: Number(parseFloat(dataItem.x).toFixed(this.chartproperties.decimalRoundOff)),
            y: Number(parseFloat(dataItem.y).toFixed(this.chartproperties.decimalRoundOff)),
            z: dataItem.size,
            metric: dataItem.metric,
            significance: dataItem.significance,
            significance1: dataItem.significance1,
            covx: dataItem.covx,
            covy: dataItem.covy,
            covz: dataItem.covz,
            samplesizex: dataItem.samplesizex,
            samplesizey: dataItem.samplesizey,
            samplesizez: dataItem.samplesizez,
            indexValuex: dataItem.indexValuex,
            actualIndexValuex: dataItem.actualIndexValuex,
            indexValuey: dataItem.indexValuey,
            actualIndexValuey: dataItem.actualIndexValuey,
            indexValuez: dataItem.indexValuez,
            actualIndexValuez: dataItem.actualIndexValuez,
            tooltip: "",
            isPercentageX: dataItem.isPercentageX,
            isPercentageY: dataItem.isPercentageY,
            isPercentageZ: dataItem.isPercentageZ,
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Valuex: dataItem.Significance_Valuex,
            Significance_Valuey: dataItem.Significance_Valuey,
            Significance_Valuez: dataItem.Significance_Valuez,
            isNullDataX: dataItem.isNullDataX,
            isNullDataY: dataItem.isNullDataY,
            isNullDataZ: dataItem.isNullDataZ,
            isIS
          };
        });

  const filteredPoints = mappedPoints.filter((p: any) => !(p.isNullDataX && p.isNullDataY && p.isNullDataZ));
  const visiblePoints = filteredPoints.filter((p: any) => !p.isIS);
  const isPoints = filteredPoints.filter((p: any) => p.isIS);
  if (isPoints.length) { hasAnyIS = true; }
  
  // Get color from the first data point's color or colorLinearGradient property
  const itemColor = item.data[0]?.color || item.data[0]?.colorLinearGradient || this.barService.brandcolors[index] || this.barService.color1[index];
  
  // push normal bubble series
  tempSeries.push({
    name: item.brand,
    type: 'bubble',
    color: itemColor,
    data: visiblePoints,
    ...(brandInfo && chartproperties['image'] && {
      marker: {
        symbol: `url(${brandInfo.image})`,
        width: brandInfo.bubble_size,
        height: brandInfo.bubble_size,
      },
    }),
  });
});
const SeriesData = tempSeries;
// Add a single origin I/S label only if any I/S exists
if (hasAnyIS && isNonSuperAdmin) {
  SeriesData.push({
    type: 'scatter',
    name: 'I/S',
    showInLegend: false,
    enableMouseTracking: false,
    data: [{ x: 0, y: 0 }],
    color: 'transparent',
    marker: { enabled: false },
    dataLabels: {
      enabled: true,
      allowOverlap: true,
      crop: false,
      overflow: 'allow',
      x: 0,
      y: 0,
      formatter: function(){ return 'I/S'; },
      style: {
        fontSize: chartproperties.dataLabelSize,
        color: chartproperties.dataLabelColor == 'Default'
          ? chartproperties.darkTheme
            ? 'white'
            : 'black'
          : chartproperties.dataLabelColor,
        textOutline: 'none',
        fontWeight: 'normal'
      }
    }
  });
}
      this.properties = this.chartproperties;
      let configService = this._configService;
      let xAxisTitle = this.xAxisTitle;
      let yAxisTitle = this.yAxisTitle;
      let zAxisTitle = this.zAxisTitle;
      const containerEl = document.getElementById(containerid);
      if (!containerEl) { return; }

      const totalPoints = SeriesData.filter((s: any) => s.type === 'bubble').reduce((sum: number, s: any) => sum + s.data.length, 0);
      if (totalPoints === 0) {
        containerEl.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
        return;
      }

      this.chart = Highcharts.chart(containerEl, {
        chart: {
          type: 'bubble',
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          // plotBorderColor: 'lightgrey',
          // plotBorderWidth: 0.5,
          style: {
            fontFamily: this.scatterchartService.fontFamily,
            fontSize: "0.7rem",
          },
          options3d: {
            enabled: chartproperties.is3DChart,
            alpha: -1,
            beta: -1,
            depth: 190,
            viewDistance: 4,
            fitToPlot: false,
          },
          zoomType: 'xy',
        },
        title: {
          text: "",
          align: chartproperties.chartTitlePosition,
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
        },
        legend: {
          enabled: popup ? true : false,
          layout:
            chartproperties.legendPosition !== 'bottom' ? 'vertical' : 'horizontal',
          verticalAlign:
            chartproperties.legendPosition !== 'bottom' ? 'middle' : 'bottom',
          align:
            chartproperties.legendPosition === 'bottom'
              ? 'center'
              : chartproperties.legendPosition,
          itemStyle: {
            color: chartproperties.darkTheme ? 'white' : 'black',
            fontFamily: "KantarBrown-Regular",
            fontSize: "0.8em",
            fontWeight: "normal"
          },
        },
        xAxis: {
          title: {
            text: this.xAxisTitle,
            style: {
              color: chartproperties.darkTheme ? 'white' : 'black',
            },
          },
          labels: {
            rotation: this.chartproperties.axisLabelOrientation === 'vertical' ? -90 : (this.chartproperties.axisLabelOrientation === 'angles' ? -45 : 0),
            format: this.properties.datalabelFormat == "number" ? '{value}' : '{value}%',
            style: {
              color: chartproperties.darkTheme ? 'white' : 'black',
            },
          },
          gridLineWidth: chartproperties.gridlines ? 0.4 : 0,
          gridLineColor: 'lightgrey',
          lineWidth: 0.3,
          min: xAxisMinValue,
          max: xAxisMaxValue,
          tickInterval:10,
          plotLines: [
            {
              color: chartproperties.dashStyle != 'none'
                ? chartproperties.showQuadrantcolor
                : 'transparent',
              dashStyle: chartproperties.dashStyle,
              value: xAxisPlotLine,
              width: 1,
              label: {
                align: 'right',
              },
            },
          ],



          plotBands: [
            {
              color: chartproperties.showGradient
                ? {
                  linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
                  stops: [
                    [0, 'rgba(0, 0, 255, 0.2)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [1, 'rgba(0, 0, 0, 0)'],
                  ],
                }
                : 'transparent',
              from: 8,
              to: maxX,
              label: {
                text: chartproperties.showQuadrantText === 'enable' ? this.quadrantText.quadrantText1 : '',
                align: 'left',
                x: 0,
                y: this.properties.is3D ? 50 : 15,
              },
            },
            {
              color: chartproperties.showGradient
                ? {
                  linearGradient: { x1: 1, x2: 0, y1: 0, y2: 0 },
                  stops: [
                    [0, 'rgba(0, 255, 0, 0.2)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [1, 'rgba(0, 0, 0, 0)'],
                  ],
                }
                : 'transparent',
              from: xAxisPlotLine,
              to: maxX,
              label: {
                text: chartproperties.showQuadrantText === 'enable' ? this.quadrantText.quadrantText2 : '',
                align: 'right',
                x: 0,
                y: this.properties.is3D ? 50 : 15,
              },
            },
          ]

        },
        yAxis: {
          title: {
            text: this.yAxisTitle,
            style: {
              color: chartproperties.darkTheme ? 'white' : 'black',
            },
          },
          labels: {
            rotation: this.chartproperties.yaxisLabelOrientation === 'vertical' ? -90 : (this.chartproperties.yaxisLabelOrientation === 'angles' ? -45 : 0),
            format: this.properties.datalabelFormat == "number" ? '{value}' : '{value}%',
            style: {
              color: chartproperties.darkTheme ? 'white' : 'black',
            },
          },
          gridLineColor: 'lightgrey',
          gridLineWidth: chartproperties.gridlines ? 0.4 : 0,
          lineWidth: 0.3,
          min: yAxisMinValue,
          max: yAxisMaxValue,
          tickInterval:10,
          plotLines: [
            {
              color: chartproperties.dashStyle != 'none'
                ? chartproperties.showQuadrantcolor
                : 'transparent',
              dashStyle: chartproperties.dashStyle,
              value: yAxisPlotLine,
              width: 1,
              label: {
                align: 'right',
              },
            },
          ],
          plotBands: [
            {
              color: chartproperties.showGradient
                ? {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, 'rgba(255, 165, 0, 0.2)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [1, 'rgba(0, 0, 0, 0)'],
                  ],
                }
                : 'transparent',
              from: 0,
              to: 0,
              label: {
                text: chartproperties.showQuadrantText === 'enable' ? this.quadrantText.quadrantText3 : '',
                align: 'right',
                x: 0,
                y: this.properties.is3D ? 50 : 50,
              },
            },
            {
              color: chartproperties.showGradient
                ? {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, 'rgba(255, 0, 0, 0.1)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [1, 'rgba(0, 0, 0, 0)'],
                  ],
                }
                : 'transparent',
              from: 100,
              to: 100,
              label: {
                text: chartproperties.showQuadrantText === 'enable' ? this.quadrantText.quadrantText4 : '',
                align: 'left',
                x: 0,
                y: chartproperties.legendPosition === 'bottom' ? 240 : (this.properties.is3D ? 250 : 320),
              },
            },
          ]
        },
        credits: {
          enabled: false
        },
        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',
            style: {
            fontSize: '0.7em'
          },
          formatter: function (
                        this: Highcharts.TooltipFormatterContextObject
                      ) {
                        const pointWithMetric = this.point as {
                          x: number;
                          y: number;
                          metric?: string;
                          covx?: string;
                          covy?: string;
                          significance?: string;
                          significance2?: string;
                          samplesizex?: number;
                          samplesizey?: number;
                          tooltip?: any;
                          isPercentageX?: any;
                          isPercentageY?: any;
                          Sig_LowerLimt?: any;
                          Sig_UpperLimt?: any;
                          Significance_Valuex?: any;
                          Significance_Valuey?: any;
                          indexValuex?: any;
                          actualIndexValuex?: any;
                          indexValuey?: any;
                          actualIndexValuey?: any;
                        };
        
                        if (pointWithMetric.metric) {
                          let tooltipContent = '';
        
                       
        
                          return tooltipContent;
                        } else {
                          let textcolor = properties.dataLabelColor;
                          if (properties.datalabelStyle == "default") {
                            let textCheckx = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.x), Number(pointWithMetric.samplesizex));
                            let textChecky = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesizey));
                            // return `<span>${this.series.name}</span><br>X: ${pointWithMetric.x}, Y: ${pointWithMetric.y}`;
                            pointWithMetric.tooltip = `<div style="border: 2px solid ${this.series.color}; background-color: white; padding: 8px; border-radius: 4px;"><span>${xAxisTitle} : ${textCheckx+(pointWithMetric.isPercentageX ? '%' : '')}</span><br><span>${yAxisTitle} : ${textChecky+(pointWithMetric.isPercentageY ? '%' : '')}</span></div>`;
                            return pointWithMetric.tooltip;
                          }
                          if (properties.datalabelStyle == "sigChange") {
                            let textCheckx = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.x), Number(pointWithMetric.samplesizex));
                            let textChecky = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesizey));
                            let changeValx = pointWithMetric.isPercentageX ? (Number(pointWithMetric.covx) * 100) : (Number(pointWithMetric.covx));
                            let changeValy = pointWithMetric.isPercentageY ? (Number(pointWithMetric.covy) * 100) : (Number(pointWithMetric.covy));
                            const tooltipBoxStyle = `border: 2px solid ${this.series.color}; background-color: white; padding: 8px; border-radius: 4px;`;
                            if ((pointWithMetric.covx == null || pointWithMetric.covx == 'NA') && (pointWithMetric.covy == null || pointWithMetric.covy == 'NA')) {
                              let textx = textCheckx + (pointWithMetric.isPercentageX ? '%' : '') + ' ' + `<span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                              let texty = textChecky + (pointWithMetric.isPercentageY ? '%' : '') + ' ' + `<span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                              pointWithMetric.tooltip = `<div style="${tooltipBoxStyle}"><span>${xAxisTitle} : ${textx}</span><br>
                              <span>${yAxisTitle} : ${texty}</span></div>`;
                              return pointWithMetric.tooltip;
                            }
                            else {
                              let sigClassx = pointWithMetric.Significance_Valuex < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Valuex > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                              let sigClassy = pointWithMetric.Significance_Valuey < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Valuey > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                              let textx = textCheckx + ((pointWithMetric.isPercentageX && textCheckx != 'I/S') ? '%' : '') + ' ' + (textCheckx != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClassx};">(` + `${(pointWithMetric.covx != null ? parseFloat(Number(changeValx).toFixed(1)) + (pointWithMetric.isPercentageX ? '%' : '') : 'NA')})</span>`) : '');
                              let texty = textChecky + ((pointWithMetric.isPercentageY && textChecky != 'I/S') ? '%' : '') + ' ' + (textChecky != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClassy};">(` + `${(pointWithMetric.covy != null ? parseFloat(Number(changeValy).toFixed(1)) + (pointWithMetric.isPercentageY ? '%' : '') : 'NA')})</span>`) : '');
                              pointWithMetric.tooltip = `<div style="${tooltipBoxStyle}"><span>${xAxisTitle} : ${textx}</span><br>
                                                         <span>${yAxisTitle} : ${texty}</span></div>`;
                              return pointWithMetric.tooltip;
        
                            }
        
                          }
                          if (properties.datalabelStyle == "index") {
                            let textx = pointWithMetric.x != null ? pointWithMetric.x + (pointWithMetric.isPercentageX ? '%' : '') : 'NA';
                            textx = configService.CheckLSorIScondition(configService.userRole, textx, Number(pointWithMetric.samplesizex));
                            let texty = pointWithMetric.y != null ? pointWithMetric.y + (pointWithMetric.isPercentageY ? '%' : '') : 'NA';
                            texty = configService.CheckLSorIScondition(configService.userRole, texty, Number(pointWithMetric.samplesizey));
                            // let text2 = pointWithMetric.y1 == 0 ? 'NA' :pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
                            let text2x = pointWithMetric.actualIndexValuex == null ? 'NA' : pointWithMetric.x == -1 ? -1 : pointWithMetric.x != null ? pointWithMetric.indexValuex.toFixed(1) : 'NA';
                            let text2y = pointWithMetric.actualIndexValuey == null ? 'NA' : pointWithMetric.y == -1 ? -1 : pointWithMetric.y != null ? pointWithMetric.indexValuey.toFixed(1) : 'NA';
        
                            if ((text2x == "-1" || text2x == -1) && (text2y == "-1" || text2y == -1)) {
                              text2x = "NA"; text2y = "NA";
                            }
                            text2x = configService.CheckLSorIScondition(configService.userRole, String(text2x), Number(pointWithMetric.samplesizex));
                            text2y = configService.CheckLSorIScondition(configService.userRole, String(text2y), Number(pointWithMetric.samplesizey));
                            let colorx = configService.CheckIndexColoring(String(text2x));
                            let colory = configService.CheckIndexColoring(String(text2y));
                            pointWithMetric.tooltip = `<div style="border: 2px solid ${this.series.color}; background-color: white; padding: 8px; border-radius: 4px;">` +
                              '<span style="color:' + textcolor + ';">' +xAxisTitle+' : '+textx + " " + '(' +
                              '<span style="color:' + colorx + ';">' + text2x + '</span>' + ')</span><br>' +
                              '<span style="color:' + textcolor + ';">'+yAxisTitle+' : '+ texty + " " + '(' +
                              '<span style="color:' + colory + ';">' + text2y + '</span>' + ')</span></div>';
                            return pointWithMetric.tooltip;
                          }
                          return null;
                        }
                      },
        },
        plotOptions: {
          series: {
            shadow: true,
            animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            },
          },
          bubble: {
            minSize: 25,
            maxSize: 40,
            // sizeBy: 'width',
            // maxSize: chartproperties.markersize !== 'default' ? chartproperties.markersize : null,
            dataLabels: {
              rotation: chartproperties.datalabelOrientation,
              enabled: chartproperties.showDataLabel,
              allowOverlap: false,
              crop: false,
              overflow: 'allow',
              y: chartproperties.datalabelStyle === 'default' ? -34 : -29,
              formatter: function (
                this: Highcharts.TooltipFormatterContextObject
              ) {
                const pointWithMetric = this.point as {
                  x: number;
                  y: number;
                  z?: number;
                  metric?: string;
                  covx?: string;
                  covy?: string;
                  covz?: string;
                  significance?: string;
                  significance2?: string;
                  samplesizex?: number;
                  samplesizey?: number;
                  samplesizez?: number;
                  tooltip?: any;
                  isPercentageX?: any;
                  isPercentageY?: any;
                  isPercentageZ?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Valuex?: any;
                  Significance_Valuey?: any;
                  Significance_Valuez?: any;
                  indexValuex?: any;
                  indexValuey?: any;
                  indexValuez?: any;
                  actualIndexValuex?: any;
                  actualIndexValuey?: any;
                  actualIndexValuez?: any;
                };

                if (pointWithMetric.metric) {
                  // let tooltipContent = '';
                  // if (chartproperties.datalabelStyle === 'change') {
                  //   const metricValue: string = pointWithMetric.metric;
                  //   return `${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}  <span style="font-size: 80%;color:${chartproperties.darkTheme ? 'white' : 'black'}">(${pointWithMetric.cv})</span>`;
                  // } else if (chartproperties.datalabelStyle === 'significance') {
                  
                  //   const metricValue: string = pointWithMetric.metric;
                  //   tooltipContent = `<span>${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}</span>`;
                  //   if (pointWithMetric.significance === '1') {
                  //     tooltipContent +=
                  //       '<span style="color: green;"> &#9650;</span>';
                  //   } else if (pointWithMetric.significance === '-1') {
                  //     tooltipContent += '<span style="color: red;"> &#9660;</span>';
                  //   } else {
                  //     tooltipContent += '';
                  //   }
                  //   return tooltipContent
                  // }
                  // if (chartproperties.datalabelStyle == "significance2") {
                  //   let changeColor = pointWithMetric.significance1 && Number(pointWithMetric.significance1) < 0 ? 'red' : (pointWithMetric.significance1 && Number(pointWithMetric.significance1) > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));
                  //   tooltipContent = `${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''} <span style="color: ${changeColor};font-size: 80%">(${pointWithMetric.cv})</span> `;
                  // }
                  // else if (
                  //   chartproperties.datalabelStyle === 'significance + changeVs'
                  // ) {
                  //   const metricValue: string = pointWithMetric.metric;
                  //   tooltipContent = `<span>${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}</span> <span style="font-size: 80%;color:${chartproperties.darkTheme ? 'white' : 'black'}">(${pointWithMetric.cv})</span> `;
                  // } else if (chartproperties.datalabelStyle === 'ls') {
                  //   const metricValue: string = pointWithMetric.metric;

                  //   if (
                  //     pointWithMetric.samplesize &&
                  //     pointWithMetric.samplesize < 12000
                  //   ) {
                  //     return 'LS';
                  //   }
                  //   return `<span>${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}</span><br>`;
                  // } else {
                  //   const metricValue: string = pointWithMetric.metric;
                  //   return `<span>${metricValue}</span><br>${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}`;
                  // }

                  // if (pointWithMetric.significance === '1') {
                  //   tooltipContent +=
                  //     '<span style="color: green;"> &#9650;</span>';
                  // } else if (pointWithMetric.significance === '-1') {
                  //   tooltipContent += '<span style="color: red;"> &#9660;</span>';
                  // } else {
                  //   tooltipContent += '';
                  // }
                  
                  // return tooltipContent;
                  return null;
                }
                else {
                  let textcolor = properties.dataLabelColor;
                  if (properties.datalabelStyle == "default") {
                    let textCheckx = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.x), Number(pointWithMetric.samplesizex));
                    let textChecky = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesizey));
                    let textCheckz = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.z), Number(pointWithMetric.samplesizez));
                    // return `<span>${this.series.name}</span><br>X: ${pointWithMetric.x}, Y: ${pointWithMetric.y}`;
                    pointWithMetric.tooltip = `<span>${xAxisTitle} : ${textCheckx+(pointWithMetric.isPercentageX ? '%' : '')}<br>${yAxisTitle} :  ${textChecky+(pointWithMetric.isPercentageY ? '%' : '')}<br>${zAxisTitle} :  ${textCheckz+(pointWithMetric.isPercentageZ ? '%' : '')}</span>`;
                    return `<span>(${textCheckx+(pointWithMetric.isPercentageX ? '%' : '')}, ${textChecky+(pointWithMetric.isPercentageY ? '%' : '')}, ${textCheckz+(pointWithMetric.isPercentageZ ? '%' : '')})</span>`;
                  }
                  if (properties.datalabelStyle == "sigChange") {
                    let textCheckx = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.x), Number(pointWithMetric.samplesizex));
                    let textChecky = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesizey));
                    let textCheckz = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.z), Number(pointWithMetric.samplesizez));
                    let changeValx = pointWithMetric.isPercentageX ? (Number(pointWithMetric.covx) * 100) : (Number(pointWithMetric.covx));
                    let changeValy = pointWithMetric.isPercentageY ? (Number(pointWithMetric.covy) * 100) : (Number(pointWithMetric.covy));
                    let changeValz = pointWithMetric.isPercentageZ ? (Number(pointWithMetric.covz) * 100) : (Number(pointWithMetric.covz));
                    if ((pointWithMetric.covx == null || pointWithMetric.covx == 'NA') && (pointWithMetric.covy == null || pointWithMetric.covy == 'NA') && (pointWithMetric.covz == null || pointWithMetric.covz == 'NA')) {
                      let textx = textCheckx + (pointWithMetric.isPercentageX ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'0'})</span>`;
                      let texty = textChecky + (pointWithMetric.isPercentageY ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'0'})</span>`;
                      let textz = textCheckz + (pointWithMetric.isPercentageZ ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'0'})</span>`;
                      let finalText = '<span style="color:' + textcolor + ';">(' + textx + '</span>, ' + '<span style="color:' + textcolor + ';">' + texty + '</span>, ' + '<span style="color:' + textcolor + ';">' + textz + '</span>'
                      pointWithMetric.tooltip = '<span style="color:' + textcolor + ';">' + xAxisTitle + ' : ' + textx + '</span><br>' + '<span style="color:' + textcolor + ';">' + yAxisTitle + ' : ' + texty + '</span><br>' + '<span style="color:' + textcolor + ';">' + zAxisTitle + ' : ' + textz + '</span>';
                      return finalText;
                    }
                    else {
                      let sigClassx = pointWithMetric.Significance_Valuex < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Valuex > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                      let sigClassy = pointWithMetric.Significance_Valuey < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Valuey > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                      let sigClassz = pointWithMetric.Significance_Valuez < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Valuez > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                      //let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + (textCheck !='I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) : 'NA'})</span>` : 'NA') : '');
                      let textx = textCheckx + ((pointWithMetric.isPercentageX && textCheckx != 'I/S') ? '%' : '') + ' ' + (textCheckx != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClassx};">(` + `${(pointWithMetric.covx != null ? parseFloat(Number(changeValx).toFixed(1)) + (pointWithMetric.isPercentageX ? '%' : '') : '0')})</span>`) : '');
                      let texty = textChecky + ((pointWithMetric.isPercentageY && textChecky != 'I/S') ? '%' : '') + ' ' + (textChecky != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClassy};">(` + `${(pointWithMetric.covy != null ? parseFloat(Number(changeValy).toFixed(1)) + (pointWithMetric.isPercentageY ? '%' : '') : '0')})</span>`) : '');
                      let textz = textCheckz + ((pointWithMetric.isPercentageZ && textCheckz != 'I/S') ? '%' : '') + ' ' + (textCheckz != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClassz};">(` + `${(pointWithMetric.covz != null ? parseFloat(Number(changeValz).toFixed(1)) + (pointWithMetric.isPercentageZ ? '%' : '') : '0')})</span>`) : '');
                      let finalText = '<span style="color:' + textcolor + ';">(' + textx + '</span>, ' + '<span style="color:' + textcolor + ';">' + texty + '</span>, ' + '<span style="color:' + textcolor + ';">' + textz + '</span>'
                      pointWithMetric.tooltip = '<span style="color:' + textcolor + ';">' + xAxisTitle + ' : ' + textx + '</span><br>' + '<span style="color:' + textcolor + ';">' + yAxisTitle + ' : ' + texty + '</span><br>' + '<span style="color:' + textcolor + ';">' + zAxisTitle + ' : ' + textz + '</span>';
                      return (
                        finalText
                      );

                    }

                  }
                  if (properties.datalabelStyle == "index") {
                    let textx = pointWithMetric.x != null ? pointWithMetric.x + (pointWithMetric.isPercentageX ? '%' : '') : 'NA';
                    textx = configService.CheckLSorIScondition(configService.userRole, textx, Number(pointWithMetric.samplesizex));
                    let texty = pointWithMetric.y != null ? pointWithMetric.y + (pointWithMetric.isPercentageY ? '%' : '') : 'NA';
                    texty = configService.CheckLSorIScondition(configService.userRole, texty, Number(pointWithMetric.samplesizey));
                    let textz = pointWithMetric.z != null ? pointWithMetric.z + (pointWithMetric.isPercentageZ ? '%' : '') : 'NA';
                    textz = configService.CheckLSorIScondition(configService.userRole, textz, Number(pointWithMetric.samplesizez));
                    // let text2 = pointWithMetric.y1 == 0 ? 'NA' :pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
                    let text2x = pointWithMetric.actualIndexValuex == null ? 'NA' : pointWithMetric.x == -1 ? -1 : pointWithMetric.x != null ? pointWithMetric.indexValuex.toFixed(1) : 'NA';
                    let text2y = pointWithMetric.actualIndexValuey == null ? 'NA' : pointWithMetric.y == -1 ? -1 : pointWithMetric.y != null ? pointWithMetric.indexValuey.toFixed(1) : 'NA';
                    let text2z = pointWithMetric.actualIndexValuez == null ? 'NA' : pointWithMetric.z == -1 ? -1 : pointWithMetric.z != null ? pointWithMetric.indexValuez.toFixed(1) : 'NA';

                    if ((text2x == "-1" || text2x == -1) && (text2y == "-1" || text2y == -1) && (text2z == "-1" || text2z == -1)) {
                      text2x = "NA"; text2y = "NA"; text2z = "NA";
                    }
                    text2x = configService.CheckLSorIScondition(configService.userRole, String(text2x), Number(pointWithMetric.samplesizex));
                    text2y = configService.CheckLSorIScondition(configService.userRole, String(text2y), Number(pointWithMetric.samplesizey));
                    text2z = configService.CheckLSorIScondition(configService.userRole, String(text2z), Number(pointWithMetric.samplesizez));
                    let colorx = configService.CheckIndexColoring(String(text2x));
                    let colory = configService.CheckIndexColoring(String(text2y));
                    let colorz = configService.CheckIndexColoring(String(text2z));
                    let finalText = '<span style="font-size:0.5rem;color:' + textcolor + ';">(' + textx + " " + '(' +
                      '<span style="color:' + colorx + ';font-size:0.45rem;">' + text2x + '</span>' + ')</span>,' +
                      '<span style="font-size:0.5rem;color:' + textcolor + ';">' + texty + " " + '(' +
                      '<span style="color:' + colory + ';font-size:0.45rem;">' + text2y + '</span>' + ')</span>,' +
                      '<span style="font-size:0.5rem;color:' + textcolor + ';">' + textz + " " + '(' +
                      '<span style="color:' + colorz + ';font-size:0.45rem;">' + text2z + '</span>' + '))</span>'
                    pointWithMetric.tooltip = '<span style="font-size:0.5rem;color:' + textcolor + ';">' + xAxisTitle + ' : ' + textx + " " + '(' +
                      '<span style="color:' + colorx + ';font-size:0.45rem;">' + text2x + '</span>' + ')</span><br>' +
                      '<span style="font-size:0.5rem;color:' + textcolor + ';">' + yAxisTitle + ' : ' + texty + " " + '(' +
                      '<span style="color:' + colory + ';font-size:0.45rem;">' + text2y + '</span>' + ')</span><br>'+
                       '<span style="font-size:0.5rem;color:' + textcolor + ';">' + yAxisTitle + ' : ' + textz + " " + '(' +
                      '<span style="color:' + colorz + ';font-size:0.45rem;">' + text2z + '</span>' + ')</span>'
                    return finalText;
                  }
                  return null;
                }
              },
              style: {
                fontSize: chartproperties.dataLabelSize,
                color: chartproperties.dataLabelColor == 'Default'
                  ? chartproperties.darkTheme
                    ? 'white'
                    : 'black'
                  : chartproperties.dataLabelColor,
                textOutline: 'none',
                fontWeight: "normal",

              },
            },
            shadow: {
              color: 'rgba(0,0,0,0.5)',
              offsetX: 0,
              offsetY: 0,
              opacity: 0.5,
              width: 5,
            },
            showInLegend: chartproperties.showLegend,
          },
        },
        series: SeriesData
      } as unknown as Highcharts.Options);

    }
    else {
      let maxX = Math.max(
        ...this.seriesData.flatMap((series: any) =>
          series.data.map((point: any) => point.x)
        )
      );
      let maxY = Math.max(
        ...this.seriesData.flatMap((series: any) =>
          series.data.map((point: any) => point.y)
        )
      );

      let yAxisPlotLine = maxY / 2;
      let xAxisPlotLine = maxX / 2;

      localStorage.setItem("properties", JSON.stringify(chartproperties));
      const threshold = this._configService?.ISthreshold ?? 0;
      const isNonSuperAdmin = true;
      // Non-output branch: build series
      const tempSeries2: any[] = [];
      let hasAnyIS2 = false;
      seriesData.forEach((item: any, index: number) => {
        const brandInfo: any = this.scatterchartService.bubbleupdatedCategories.find(
          (category: { name: any }) => category.name === item.brand);
        const mappedPoints = item.data.map((dataItem: any) => {
          const s = Number(dataItem.samplesize ?? 0);
          const isIS = isNonSuperAdmin && (s <= threshold);
          return {
            x: Number(parseFloat(dataItem.x).toFixed(this.chartproperties.decimalRoundOff)),
            y: Number(parseFloat(dataItem.y).toFixed(this.chartproperties.decimalRoundOff)),
            z: dataItem.size,
            metric: dataItem.metric,
            significance: dataItem.significance,
            significance1: dataItem.significance1,
            cv: dataItem.cv,
            samplesize: dataItem.samplesize,
            isIS
          };
        });
  const visiblePoints = mappedPoints.filter((p: any) => !p.isIS);
  const isPoints = mappedPoints.filter((p: any) => p.isIS);
  if (isPoints.length) { hasAnyIS2 = true; }
        tempSeries2.push({
          name: item.brand,
          type: 'bubble',
          color: this.scatterchartService.color[index],
          data: visiblePoints,
          ...(brandInfo && chartproperties['image'] && {
            marker: {
              symbol: `url(${brandInfo.image})`,
              width: brandInfo.bubble_size,
              height: brandInfo.bubble_size,
            },
          }),
        });
        // REMOVE per-brand I/S scatter series
      });
      const SeriesData = tempSeries2;
      if (hasAnyIS2 && isNonSuperAdmin) {
        SeriesData.push({
          type: 'scatter',
          name: 'I/S',
          showInLegend: false,
          enableMouseTracking: false,
          data: [{ x: 0, y: 0 }],
          color: 'transparent',
          marker: { enabled: false },
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            crop: false,
            overflow: 'allow',
            x: 0,
            y: 0,
            formatter: function(){ return 'I/S'; },
            style: {
              fontSize: chartproperties.dataLabelSize,
              color: chartproperties.dataLabelColor == 'Default'
                ? chartproperties.darkTheme
                  ? 'white'
                  : 'black'
                : chartproperties.dataLabelColor,
              textOutline: 'none',
              fontWeight: 'normal'
            }
          }
        });
      }


      const containerEl = document.getElementById(containerid);
      if (!containerEl) { return; }
      this.chart = Highcharts.chart(containerEl, {
        chart: {
          type: 'bubble',
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          plotBorderColor: 'lightgrey',
          plotBorderWidth: 0.5,
          style: {
            fontFamily: this.scatterchartService.fontFamily,
          },
          options3d: {
            enabled: chartproperties.is3DChart,
            alpha: -1,
            beta: -1,
            depth: 190,
            viewDistance: 4,
            fitToPlot: false,
          },
          zoomType: 'xy',
        },
        title: {
          text: "",
          align: chartproperties.chartTitlePosition,
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
        },
        legend: {
          enabled: chartproperties.showLegend,
          layout:
            chartproperties.legendPosition !== 'bottom' ? 'vertical' : 'horizontal',
          verticalAlign:
            chartproperties.legendPosition !== 'bottom' ? 'middle' : 'bottom',
          align:
            chartproperties.legendPosition === 'bottom'
              ? 'center'
              : chartproperties.legendPosition,
          itemStyle: {
            color: chartproperties.darkTheme ? 'white' : 'black',
            fontFamily: "KantarBrown-Regular",
            fontSize: "0.8em",
            fontWeight: "normal"
          },
        },
        xAxis: {
          title: {
            text: '',
          },
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
          labels: {
            rotation: this.chartproperties.axisLabelOrientation === 'vertical' ? -90 : (this.chartproperties.axisLabelOrientation === 'angles' ? -45 : 0),
            format: this.properties.datalabelFormat == "number" ? '{value}' : '{value}%',
            style: {
              color: chartproperties.darkTheme ? 'white' : 'black',
            },
          },
          gridLineWidth: chartproperties.gridlines ? 0.4 : 0,
          gridLineColor: 'lightgrey',
          lineWidth: 0.3,
          plotLines: [
            {
              color: chartproperties.dashStyle != 'none'
                ? chartproperties.showQuadrantcolor
                : 'transparent',
              dashStyle: chartproperties.dashStyle,
              value: this.quadrantHalfValue(seriesData, 'x'),
              width: 1,
              label: {
                align: 'right',
              },
            },
          ],



          plotBands: [
            {
              color: chartproperties.showGradient
                ? {
                  linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
                  stops: [
                    [0, 'rgba(0, 0, 255, 0.2)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [1, 'rgba(0, 0, 0, 0)'],
                  ],
                }
                : 'transparent',
              from: 8,
              to: maxX,
              label: {
                text: chartproperties.showQuadrantText === 'enable' ? this.quadrantText.quadrantText1 : '',
                align: 'left',
                x: 0,
                y: this.properties.is3D ? 50 : 15,
              },
            },
            {
              color: chartproperties.showGradient
                ? {
                  linearGradient: { x1: 1, x2: 0, y1: 0, y2: 0 },
                  stops: [
                    [0, 'rgba(0, 255, 0, 0.2)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [1, 'rgba(0, 0, 0, 0)'],
                  ],
                }
                : 'transparent',
              from: xAxisPlotLine,
              to: maxX,
              label: {
                text: chartproperties.showQuadrantText === 'enable' ? this.quadrantText.quadrantText2 : '',
                align: 'right',
                x: 0,
                y: this.properties.is3D ? 50 : 15,
              },
            },
          ]

        },
        yAxis: {
          title: {
            text: '',
            style: {
              color: chartproperties.darkTheme ? 'white' : 'black',
            },
          },
          labels: {
            rotation: this.chartproperties.yaxisLabelOrientation === 'vertical' ? -90 : (this.chartproperties.yaxisLabelOrientation === 'angles' ? -45 : 0),
            format: this.properties.datalabelFormat == "number" ? '{value}' : '{value}%',
            style: {
              color: chartproperties.darkTheme ? 'white' : 'black',
            },
          },
          gridLineColor: 'lightgrey',
          gridLineWidth: chartproperties.gridlines ? 0.4 : 0,
          lineWidth: 0.3,
          plotLines: [
            {
              color: chartproperties.dashStyle != 'none'
                ? chartproperties.showQuadrantcolor
                : 'transparent',
              dashStyle: chartproperties.dashStyle,
              value: this.quadrantHalfValue(seriesData, 'x'),
              width: 1,
              label: {
                align: 'right',
              },
            },
          ],
          plotBands: [
            {
              color: chartproperties.showGradient
                ? {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, 'rgba(255, 165, 0, 0.2)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [1, 'rgba(0, 0, 0, 0)'],
                  ],
                }
                : 'transparent',
              from: 0,
              to: 0,
              label: {
                text: chartproperties.showQuadrantText === 'enable' ? this.quadrantText.quadrantText3 : '',
                align: 'right',
                x: 0,
                y: this.properties.is3D ? 50 : 50,
              },
            },
            {
              color: chartproperties.showGradient
                ? {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, 'rgba(255, 0, 0, 0.1)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [0.5, 'rgba(0, 0, 0, 0)'],
                    [1, 'rgba(0, 0, 0, 0)'],
                  ],
                }
                : 'transparent',
              from: 100,
              to: 100,
              label: {
                text: chartproperties.showQuadrantText === 'enable' ? this.quadrantText.quadrantText4 : '',
                align: 'left',
                x: 0,
                y: chartproperties.legendPosition === 'bottom' ? 240 : (this.properties.is3D ? 250 : 320),
              },
            },
          ]
        },
        credits: {
          enabled: false
        },
        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',
          formatter: function (this: Highcharts.TooltipFormatterContextObject) {
            const pointWithMetric = this.point as {
              x: number;
              y: number;
              metric?: string;
              z?: number;
            };


            let isDefaultTooltip = chartproperties.toolTipStyle;
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (isDefaultTooltip == "style1") {
              const dotColor = this.series.color;
              const commonContent =
                `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 0px; border-radius: 5px; margin: 0; background-color: white;">` +
                `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
                `<span><strong>Category Name:</strong></span> ${this.series.name}<br>` +
                `<span><strong>Value:</strong></span> ${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''} <br>` +
                `<span><strong>Bubble Size:</strong></span> ${pointWithMetric.z}`;
              return commonContent + '</div>';
            }
            else {
              // const dotColor = this.series.color;
              // const content =
              //   `<div style="background-color: #f5f5f5; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
              //   `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"></div>` +
              //   ` ${this.series.name}` +
              //   `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}</div>`;
              // return content + '</div>';
              const dotColor = this.series.color;
              const commonContent =
              `<div style="border-left: 2px solid ` + dotColor + `;font-size:0.8rem; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
              `<span> ${this.series.name}</span> : ` +
              `${pointWithMetric.y}`;
            return commonContent + '</div>';
            }
          },
        },
        plotOptions: {
          series: {
            shadow: true,
            animation: false
          },
          bubble: {
            maxSize: chartproperties.markersize !== 'default' ? chartproperties.markersize : null,
            dataLabels: {
              rotation: chartproperties.datalabelOrientation,
              crop: false,
              overflow: 'allow',
              enabled: chartproperties.showDataLabel,
              y: chartproperties.datalabelStyle === 'default' ? -34 : -29,
              formatter: function (
                this: Highcharts.TooltipFormatterContextObject
              ) {
                const pointWithMetric = this.point as {
                  x: number;
                  y: number;
                  metric?: string;
                  cv?: string;
                  significance?: string;
                  significance1?: string;
                  samplesize?: number;
                };

                if (pointWithMetric.metric) {
                  let tooltipContent = '';
                  if (chartproperties.datalabelStyle === 'change') {
                    const metricValue: string = pointWithMetric.metric;
                    return `${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}  <span style="font-size: 80%;color:${chartproperties.darkTheme ? 'white' : 'black'}">(${pointWithMetric.cv})</span>`;
                  } else if (chartproperties.datalabelStyle === 'significance') {
                    const metricValue: string = pointWithMetric.metric;
                    tooltipContent = `<span>${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}</span>`;
                    if (pointWithMetric.significance === '1') {
                      tooltipContent +=
                        '<span style="color: green;"> &#9650;</span>';
                    } else if (pointWithMetric.significance === '-1') {
                      tooltipContent += '<span style="color: red;"> &#9660;</span>';
                    } else {
                      tooltipContent += '';
                    }
                    return tooltipContent
                  }
                  if (chartproperties.datalabelStyle == "significance2") {
                    let changeColor = pointWithMetric.significance1 && Number(pointWithMetric.significance1) < 0 ? 'red' : (pointWithMetric.significance1 && Number(pointWithMetric.significance1) > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));
                    tooltipContent = `${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''} <span style="color: ${changeColor};font-size: 80%">(${pointWithMetric.cv})</span> `;
                  }
                  else if (
                    chartproperties.datalabelStyle === 'significance + changeVs'
                  ) {
                    const metricValue: string = pointWithMetric.metric;
                    tooltipContent = `<span>${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}</span> <span style="font-size: 80%;color:${chartproperties.darkTheme ? 'white' : 'black'}">(${pointWithMetric.cv})</span> `;
                  } else if (chartproperties.datalabelStyle === 'ls') {
                    const metricValue: string = pointWithMetric.metric;

                    if (
                      pointWithMetric.samplesize &&
                      pointWithMetric.samplesize < 12000
                    ) {
                      return 'LS';
                    }
                    return `<span>${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}</span><br>`;
                  } else {
                    const metricValue: string = pointWithMetric.metric;
                    return `<span>${metricValue}</span><br>${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}`;
                  }

                  if (pointWithMetric.significance === '1') {
                    tooltipContent +=
                      '<span style="color: green;"> &#9650;</span>';
                  } else if (pointWithMetric.significance === '-1') {
                    tooltipContent += '<span style="color: red;"> &#9660;</span>';
                  } else {
                    tooltipContent += '';
                  }
                  return tooltipContent;
                } else {
                  return `<span>${this.series.name}</span><br>${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}`;
                }
              },
              style: {
                fontSize: chartproperties.dataLabelSize,
                color: chartproperties.dataLabelColor == 'Default'
                  ? chartproperties.darkTheme
                    ? 'white'
                    : 'black'
                  : chartproperties.dataLabelColor,
                textOutline: 'none',
                fontWeight: "normal",

              },
            },
            shadow: {
              color: 'rgba(0,0,0,0.5)',
              offsetX: 0,
              offsetY: 0,
              opacity: 0.5,
              width: 5,
            },
            showInLegend: chartproperties.showLegend,
          },
        },
        series: SeriesData
      } as unknown as Highcharts.Options);
    }
  }



  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.scatterchartService.applycustomization(event, item, this.chartproperties)
    this.getBubbleChart('chart-container' + this.id, this.seriesData, this.chartproperties);
  }



  userselectedproperties() {

    let quadrantName = [this.quadrantText.quadrantText1, this.quadrantText.quadrantText2,
    this.quadrantText.quadrantText3, this.quadrantText.quadrantText4];
    const jsonData = {
      title: this.title,
      data: this.seriesData,
      properties: this.properties,
      quadrantText: quadrantName
    }

    return JSON.stringify(jsonData);
  }


  private updateSigSub: Subscription | null = null;

  ngOnDestroy(): void {
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
